"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDetailPerformanceValue = exports.createPeriodicDetailPerformanceCreative = exports.createPeriodicDetailPerformance = void 0;
const creation_1 = require("../creation");
const PerformanceValue_1 = require("../DailyPerformanceValue/PerformanceValue");
const performanceReportPeriod_1 = require("./performanceReportPeriod");
const createPeriodicDetailPerformance = (object = {
    period: performanceReportPeriod_1.createPerformanceReportPeriod(),
    creatives: [exports.createPeriodicDetailPerformanceCreative()],
}) => object;
exports.createPeriodicDetailPerformance = createPeriodicDetailPerformance;
const createPeriodicDetailPerformanceCreative = (object = {
    creativeId: '',
    creation: creation_1.createSomeCreation(),
    values: [exports.createDetailPerformanceValue()],
    adName: '',
    thumbnailImageUrl: '',
}) => object;
exports.createPeriodicDetailPerformanceCreative = createPeriodicDetailPerformanceCreative;
const createDetailPerformanceValue = (object = {
    metric: 'click_through_rate',
    actualValue: PerformanceValue_1.createPerformanceValue(),
}) => object;
exports.createDetailPerformanceValue = createDetailPerformanceValue;
